import React from 'react';
import { useDispatch } from 'react-redux';
import { withFormik, Field, Form, getIn } from 'formik';
import * as Yup from 'yup';
import { Button, Row, Col, Modal } from 'react-bootstrap';
import { indexDocumentTemplateRequest } from '../../requests/documentTemplates';
import { InputSelect, FormikInput } from '../../components';

const ContractCertificate = ({ errors, touched, setFieldValue, isSubmitting, customParams }) => {
  const dispatch = useDispatch();

  const fetchDocumentTemplates = (inputValue, callback) => {
    indexDocumentTemplateRequest({
      dispatch,
      params: {
        ...customParams,
        query: inputValue,
        sort_column: 'name',
        display_length: 150
      },
      successCallback: response => callback(response.data.data)
    });
  };

  return (
    <Form>
      <Modal.Body>
        <h4 className="mt-0 mb-4">Seleccione la plantilla que será enviada al correo del empleado</h4>
        <Row>
          <Col>
            <Field name="templatePdf[templateId]">
              {({ field }) => (
                <InputSelect
                  {...field}
                  abbr
                  label="Plantilla"
                  placeholder="Seleccionar Plantilla"
                  value={undefined}
                  request={fetchDocumentTemplates}
                  onChange={data => {
                    setFieldValue('templatePdf[documentType]', data.template_type);
                    setFieldValue(field.name, data ? data.value : '');
                  }}
                  error={getIn(errors, field.name)}
                  touched={getIn(touched, field.name)}
                />
              )}
            </Field>
          </Col>
          {customParams.template_type === 'reprimand_document' && (
            <Col md={12}>
              <Field name="templatePdf[extraKeys][0][value]">
                {({ field }) => (
                  <FormikInput
                    {...field}
                    abbr
                    as="textarea"
                    label="Motivo de amonestación"
                    minInputHeight="120"
                    error={getIn(errors, field.name)}
                    touched={getIn(touched, field.name)}
                  />
                )}
              </Field>
            </Col>
          )}
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button type="submit" variant="primary" disabled={isSubmitting}>
          Generar
        </Button>
      </Modal.Footer>
    </Form>
  );
};

const setInitialValues = props => {
  const { documentType = 'certificate' } = props;
  return {
    templatePdf: {
      documentType,
      templateId: '',
      extraKeys: [{ code: '[[motivo_amonestacion]]', value: '' }]
    }
  };
};

const validationSchema = Yup.object().shape({
  templatePdf: Yup.object().shape({
    templateId: Yup.string().required('Debes seleccionar una plantilla')
  })
});

const handleSubmit = (values, { props, setSubmitting }) => {
  const { formRequest } = props;
  formRequest(values, setSubmitting);
};

export default withFormik({
  mapPropsToValues: setInitialValues,
  validationSchema,
  handleSubmit,
  enableReinitialize: true
})(ContractCertificate);
